<script setup lang="ts">
import { computed } from 'vue';
import { Badge } from '@/components/ui/badge';
import {
  getBackgroundColor,
  getTextColor,
  type BookingStatus,
} from '@/utils/booking-status';

const props = defineProps<{
  status: BookingStatus;
}>();

const style = computed(() => ({
  backgroundColor: getBackgroundColor(props.status) ?? undefined,
  color: getTextColor(props.status) ?? undefined,
}));
</script>

<template>
  <Badge :style="style">
    {{ status.label }}
  </Badge>
</template>
